import {createContext} from "react";

const QuickbooksContext = createContext();

export default QuickbooksContext;